/* Publish by EComposer at 2025-07-30 09:29:10*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-s9y22l1pzob"]=  window.__ectimmers["ecom-s9y22l1pzob"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-s9y22l1pzob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s9y22l1pzob', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7e1sh4qhxy4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7e1sh4qhxy4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0k47mk7zje8t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0k47mk7zje8t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yp5iu4jkmr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yp5iu4jkmr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mxidcjltt1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mxidcjltt1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tgy7u7mhfhm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tgy7u7mhfhm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5n4y2qmda0a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5n4y2qmda0a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-avzznv9g2k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-avzznv9g2k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-006kgjxn0gqy8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-006kgjxn0gqy8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qybaz6etshc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qybaz6etshc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ir0pw74wed').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ir0pw74wed', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xtti7wumd4d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xtti7wumd4d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cgr5bt6zjfo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cgr5bt6zjfo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hnp6bkmjnjv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hnp6bkmjnjv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2hmv9v6fqy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2hmv9v6fqy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v4o0t8p6wwk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v4o0t8p6wwk', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9wr2chko94p"]=  window.__ectimmers["ecom-9wr2chko94p"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-9wr2chko94p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9wr2chko94p', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3by8fk71coo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3by8fk71coo', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gkqpbbp8op4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gkqpbbp8op4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}